import { Component, input } from '@angular/core';

@Component({
  selector: 'rid-chevron',
  imports: [],
  templateUrl: './rid-chevron.html',
})
export class RidChevron {
  direction = input<'LEFT' | 'RIGHT'>('RIGHT');
}
